import Form from 'antd/es/form';
import Select from 'antd/es/select';
import React from 'react';

interface EnumSelectProps {
  label: string;
  name: string;
  options: Array<{ value: string; label: string }>;
  placeholder?: string;
  required?: boolean;
  help?: string;
}

export const EnumSelect: React.FC<EnumSelectProps> = ({
  label,
  name,
  options,
  placeholder,
  required = false,
  help,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={
        required
          ? [{ required: true, message: `${label} is required` }]
          : undefined
      }
      help={help}
    >
      <Select placeholder={placeholder}>
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
